export const INTERVENTION_MANAGEMENT = {
    en: "Intervention management",
    ro: "Management interventii"
};